// extracted by mini-css-extract-plugin
export var option = "_c5-0";
export var optionCard = "_c5-f";
export var optionContent = "_c5-g";
export var optionIcon = "_c5-i";
export var optionIconBox = "_c5-h";
export var optionLabel = "_c5-j";
export var optionPill = "_c5-m";
export var optionPillBadge = "_c5-p";
export var optionPillIcon = "_c5-n";
export var optionPillLabel = "_c5-o";
export var optionRadio = "_c5-k";
export var optionRadioInner = "_c5-l";
export var optionReveal = "_c5-2";
export var optionRevealDelay0 = "_c5-3";
export var optionRevealDelay1 = "_c5-4";
export var optionRevealDelay10 = "_c5-d";
export var optionRevealDelay11 = "_c5-e";
export var optionRevealDelay2 = "_c5-5";
export var optionRevealDelay3 = "_c5-6";
export var optionRevealDelay4 = "_c5-7";
export var optionRevealDelay5 = "_c5-8";
export var optionRevealDelay6 = "_c5-9";
export var optionRevealDelay7 = "_c5-a";
export var optionRevealDelay8 = "_c5-b";
export var optionRevealDelay9 = "_c5-c";
export var optionSelected = "_c5-1";